<mat-toolbar class="contactsbg">

    <div>
        <button mat-icon-button *ngIf="!pageConfig.edit || new" (click)="goBack()">
            <mat-icon>keyboard_arrow_left</mat-icon>
        </button>
        <a mat-icon-button (click)="displayItem()" *ngIf="pageConfig.edit && !new">
            <mat-icon>keyboard_arrow_left</mat-icon>
        </a>
        <div class="title">
            <mat-icon>{{GLOBAL.ICONS.CONTACT}}</mat-icon>
            <ng-container *ngIf="!new">
                I{{item.values.ref}}:
                {{item.values.fullname}}
            </ng-container>
            <ng-container *ngIf="new">New Contact</ng-container>
        </div>
    </div>
    <div>
        <profile></profile>
        <button mat-icon-button [matMenuTriggerFor]="menu">
            <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="addBroker()"
                *ngIf="!brokerKey && this.checkAccessContact() && this.isOneOfRoles(['admin', 'director', 'assistant'])">
                <mat-icon>{{GLOBAL.ICONS.BROKER}}</mat-icon>
                <span>Add Broker</span>
            </button>
            <button mat-menu-item (click)="logs()">
                <mat-icon>{{GLOBAL.ICONS.LOGS}}</mat-icon>
                <span>Logs</span>
            </button>
        </mat-menu>
    </div>

</mat-toolbar>
<div class="toolbartop"></div>

<div class="mdc-layout-grid contactPage" *ngIf="!new">
    <div class="mdc-layout-grid__inner">

        <ng-container *ngIf="item.values.duplicateKey && !item.values.notDuplicate">
            <div class="mdc-layout-grid__cell--span-12">
                <mat-card class="full warningbg mat-elevation-z4">
                    <mat-card-content>
                        <mat-list>
                            <mat-list-item>
                                <mat-icon color="warn" matListIcon>
                                    {{GLOBAL.ICONS.ALERT}}</mat-icon>
                                <h3 matLine>Potential Duplicate
                                    Detected!</h3>
                            </mat-list-item>
                        </mat-list>

                        <mat-list-item>
                            <p matLine>
                                One of the emails or phone numbers matches an existing contact in your CRM.
                                Please review carefully before merging.</p>
                        </mat-list-item>

                        <mat-list-item>
                            <p matLine>
                                <i> Do not merge contacts that belong to different people (for example, a husband
                                    and wife who share a phone number or email).
                                    If they are not the same person, mark as “Different Contacts”.</i>
                            </p>
                        </mat-list-item>
                    </mat-card-content>
                </mat-card>
            </div>
            <div class="mdc-layout-grid__cell--span-1">
            </div>
            <div class="mdc-layout-grid__cell--span-4" *ngIf="item.values.$key">
                <app-contact-tab [key]="item.values.$key" [options]="{displayOnly:true, displayRef:true}">
                </app-contact-tab>
            </div>
            <div class="mdc-layout-grid__cell--span-2">
                <div style="display:flex; align-items:center; justify-content:center; height:100%;">
                    <mat-icon style="font-size:48px; line-height:48px;">{{GLOBAL.ICONS.MERGE}}</mat-icon>
                </div>
            </div>
            <div class="mdc-layout-grid__cell--span-4">
                <app-contact-tab [key]="item.values.duplicateKey"
                    [options]="{displayOnly:true, displayRef:true, link:true, backLinkKey:item.values.$key}">
                </app-contact-tab>
            </div>
        </ng-container>

        <!-- <mat-card class="full">
                        <mat-list *ngIf="pageConfig.loaded">
                            <mat-list-item>
                                <mat-icon matListIcon>
                                    {{GLOBAL.ICONS.CONTACT}}</mat-icon>
                                <h3 matLine> {{item.values.fullname}} </h3>
                            </mat-list-item>
                            <mat-list-item *ngIf="item.values.nationalities && item.values.nationalities.length">
                                <mat-icon matListIcon>
                                    {{GLOBAL.ICONS.FLAG}}</mat-icon>
                                <h3 matLine>
                                    <ng-container *ngFor="let n of item.values.nationalities; let i = index">
                                        {{i > 0 ? ', ' : '' }}{{n | param:'countries'}}</ng-container>
                                </h3>
                            </mat-list-item>
                            <mat-list-item *ngIf="item.values.country">
                                <mat-icon matListIcon>{{GLOBAL.ICONS.UNIT}}</mat-icon>
                                <h3 matLine>{{item.values.country | param:'countries'}}</h3>
                            </mat-list-item>
                            <mat-list-item>
                                <mat-icon matListIcon>
                                    {{GLOBAL.ICONS.LANG}}</mat-icon>
                                <h3 matLine> {{item.values.lang | param:'langs'}} </h3>
                            </mat-list-item>
                            <mat-list-item *ngIf="item.values.birthday">
                                <mat-icon matListIcon>
                                    {{GLOBAL.ICONS.BIRTH}}</mat-icon>
                                <h3 matLine> {{item.values.birthday | date:'dd MMM yyyy'}} </h3>
                            </mat-list-item>
                            <ng-container *ngIf="item.values.tels">
                                <mat-list-item *ngFor="let tel of item.values.tels | toarray">
                                    <mat-icon matListIcon>{{GLOBAL.ICONS.PHONE}}</mat-icon>
                                    <h3 matLine>{{tel.number}}</h3>
                                </mat-list-item>
                            </ng-container>
                            <ng-container *ngIf="item.values.emails">
                                <mat-list-item *ngFor="let email of item.values.emails | toarray">
                                    <mat-icon matListIcon>{{GLOBAL.ICONS.EMAIL}}</mat-icon>
                                    <h3 matLine>{{email.email}}</h3>
                                </mat-list-item>
                            </ng-container>

                            <ng-container *ngIf="item.values.synaps?.employeesArray">
                                <mat-list-item *ngFor="let e of item.values.synaps?.employeesArray">
                                    <mat-icon matListIcon>{{GLOBAL.ICONS.WORK}}</mat-icon>
                                    <h3 matLine>{{e.displayname}}</h3>
                                </mat-list-item>
                            </ng-container>


                            <ng-container *ngIf="item.values.synaps?.contactBrokerObj?.status === 'active'">
                                <mat-list-item>
                                    <mat-icon matListIcon>{{GLOBAL.ICONS.BROKER}}</mat-icon>
                                    <h3 matLine>Broker: {{item.values.synaps?.contactBrokerObj.fee}}%</h3>
                                </mat-list-item>
                            </ng-container>

                        </mat-list>
                    </mat-card> -->


        <ng-container>
            <div class="mdc-layout-grid__cell--span-4"
                *ngIf="item.values.$key && (!item.values.duplicateKey || item.values.notDuplicate)">
                <app-contact-tab [key]="item.values.$key">
                </app-contact-tab>
            </div>
            <div class="mdc-layout-grid__cell--span-8">
                <ng-container *ngIf="item.values.synaps?.contactsProjectsArray">
                    <table mat-table [dataSource]="item.values.synaps?.contactsProjectsArray" class="mat-elevation-z8">

                        <ng-container matColumnDef="icon">
                            <th mat-header-cell *matHeaderCellDef> <mat-icon>{{GLOBAL.ICONS.PROJECT}}</mat-icon>
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <mat-icon matListIcon [ngClass]="element.iconColor">{{element.icon}}</mat-icon>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="ref">
                            <th mat-header-cell *matHeaderCellDef>Ref</th>
                            <td mat-cell *matCellDef="let element"> C{{element.ref}} </td>
                        </ng-container>

                        <ng-container matColumnDef="unitTypes">
                            <th mat-header-cell *matHeaderCellDef>Unit Types</th>
                            <td mat-cell *matCellDef="let element">
                                <mat-icon *ngFor="let icon of element.unitTypeIcons">{{icon | icon:'unitTypes'}}
                                </mat-icon>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="minBedrooms">
                            <th mat-header-cell *matHeaderCellDef>Min Beds</th>
                            <td mat-cell *matCellDef="let element">{{element.minBedrooms}} </td>
                        </ng-container>

                        <ng-container matColumnDef="budget">
                            <th mat-header-cell *matHeaderCellDef>Budget</th>
                            <td mat-cell *matCellDef="let element">{{element.budget}} </td>
                        </ng-container>

                        <ng-container matColumnDef="days">
                            <th mat-header-cell *matHeaderCellDef>Moving on</th>
                            <td mat-cell *matCellDef="let element">
                                <span>{{element.dateNeed?.toDate() | date:'dd MMM yyyy'}}</span>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="realtor">
                            <th mat-header-cell *matHeaderCellDef>Agent</th>
                            <td mat-cell *matCellDef="let element">
                                <img mat-card-avatar *ngIf="element.realtor" class="realtor"
                                    [src]="element.realtor | realtor" [matTooltip]="element.realtor | realtorName" />
                            </td>
                        </ng-container>


                        <tr class="projectsbg" mat-header-row
                            *matHeaderRowDef="['icon','ref','unitTypes','minBedrooms','budget','days','realtor']">
                        </tr>
                        <tr mat-row
                            *matRowDef="let row; let element; columns: ['icon','ref','unitTypes','minBedrooms','budget','days','realtor'];"
                            (click)="goItem('projects', element)">
                        </tr>
                    </table>
                </ng-container>
                <div class="spacer" style="height:20px"></div>

                <ng-container *ngIf="item.values.synaps?.ownersArray">
                    <table mat-table [dataSource]="item.values.synaps.ownersArray" class="mat-elevation-z8">

                        <ng-container matColumnDef="type">
                            <th mat-header-cell *matHeaderCellDef><mat-icon>{{GLOBAL.ICONS.UNIT}}</mat-icon></th>
                            <td mat-cell *matCellDef="let element">
                                <mat-icon matListIcon [ngClass]="{active: element.active}">
                                    {{setting.getParamIcon('unitTypes', element.type)}}
                                </mat-icon>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="ref">
                            <th mat-header-cell *matHeaderCellDef> Ref </th>
                            <td mat-cell *matCellDef="let element"> P{{element.ref}} </td>
                        </ng-container>
                        <ng-container matColumnDef="city">
                            <th mat-header-cell *matHeaderCellDef> City </th>
                            <td mat-cell *matCellDef="let element">
                                {{element.city}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="unit">
                            <th mat-header-cell *matHeaderCellDef>Unit</th>
                            <td mat-cell *matCellDef="let element">
                                {{element.residence}} -
                                {{element.unitNb}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="bedrooms">
                            <th mat-header-cell *matHeaderCellDef>Bedrooms</th>
                            <td mat-cell *matCellDef="let element">
                                {{element.bedrooms}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="bathrooms">
                            <th mat-header-cell *matHeaderCellDef>Bathrooms</th>
                            <td mat-cell *matCellDef="let element">
                                {{element.bathrooms}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="surface">
                            <th mat-header-cell *matHeaderCellDef>Surface</th>
                            <td mat-cell *matCellDef="let element">
                                <!-- <ng-container *ngIf="element.type != 'land'"> -->
                                {{element.surface ? element.surface + ' m²' : ''}}
                                <!-- </ng-container> -->
                                <!-- <ng-container *ngIf="element.type == 'land'"> {{element.landSurface}}
                    {{element.surface | param:'landUnits'}}
                </ng-container> -->
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="mandates">
                            <th mat-header-cell *matHeaderCellDef> Mandates </th>
                            <td mat-cell *matCellDef="let element">
                                <ng-container *ngFor="let mandate of element.mandates; let i = index"><br
                                        *ngIf="i" />{{mandate}}
                                </ng-container>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="realtors">
                            <th mat-header-cell *matHeaderCellDef> Agents </th>
                            <td mat-cell *matCellDef="let element">
                                <img *ngIf="element.saleRealtor" mat-card-avatar [src]="element.saleRealtor | realtor"
                                    [matTooltip]="element.saleRealtor | realtorName" />
                                <img *ngIf="element.rentalRealtor" mat-card-avatar
                                    [src]="element.rentalRealtor | realtor"
                                    [matTooltip]="element.rentalRealtor | realtorName" />
                            </td>
                        </ng-container>

                        <tr mat-header-row class="unitsbg"
                            *matHeaderRowDef="['type','city','unit', 'bedrooms', 'bathrooms', 'surface','mandates','ref', 'realtors']">
                        </tr>
                        <tr mat-row
                            *matRowDef="let row; let element; columns: ['type','city','unit', 'bedrooms', 'bathrooms', 'surface','mandates','ref', 'realtors'];"
                            (click)="goItem('units', element)" class="cursor">
                        </tr>
                    </table>
                </ng-container>
            </div>

        </ng-container>

    </div>
</div>

<!-- NEW -->
<div class="mdc-layout-grid" *ngIf="new">
    <div class="mdc-layout-grid__inner">
        <div class="mdc-layout-grid__cell--span-4">
            <form-builder [item]="item" [values]="item.values" section="main" [edit]="true"></form-builder>
        </div>
        <div class="mdc-layout-grid__cell--span-4">
            <form-builder [item]="item" [values]="item.values" section="emails" [edit]="true">
            </form-builder>
        </div>
        <div class="mdc-layout-grid__cell--span-4">
            <form-builder [item]="item" [values]="item.values" section="tels" [edit]="true"></form-builder>

        </div>
    </div>
</div>


<mat-spinner [strokeWidth]="5" class="fixed" *ngIf="!(pageConfig.loaded || new)"></mat-spinner>

<!------------------------------ BUTTONS  ----------------------------------------->
<!-- NEW -->
<button *ngIf="new" mat-fab class="bottom-right pfixed" [disabled]="!item.valid || !item.modified || item.saving"
    (click)="saveNewItem()">
    <mat-icon matListIcon>check</mat-icon>
</button>
<!-- EDIT -->
<!-- <button *ngIf="!new && !pageConfig.edit" mat-fab class="bottom-right pfixed" (click)="editItem()">
        <mat-icon matListIcon>edit</mat-icon>
    </button> -->
<ng-container *ngIf="!new && checkAccessContact()">


    <!-- DELETE -->
    <button *ngIf="isRole('admin')" mat-fab class="bottom-left pfixed" color="basic" (click)="db.deleteItem(item)">
        <mat-icon matListIcon>delete</mat-icon>
    </button>

    <!-- NEW PROJECT & SELECT COMPANY -->

    <ng-container *ngIf="!item.values.duplicateKey">
        <!-- NEW PROJECT -->
        <button color="primary" mat-fab class="bottom-right pfixed" (click)="addProject()" matTooltip="Add Project">
            <mat-icon matListIcon>{{GLOBAL.ICONS.PROJECTADD}}</mat-icon>
        </button>

        <!-- SELECT COMPANY -->
        <button mat-fab class="bottom-right pfixed p2" color="basic" (click)="select.init(item, db, 'employees')"
            matTooltip="Select Company">
            <mat-icon matListIcon>{{GLOBAL.ICONS.COMPANY}}</mat-icon>
        </button>

    </ng-container>


    <!-- DUPLICATE MODE BUTTONS -->
    <ng-container *ngIf="item.values.duplicateKey && !item.values.notDuplicate">
        <button color="primary" mat-fab class="bottom-right pfixed p2" matTooltip="Merge" (click)="mergeContact()">
            <mat-icon matListIcon>{{GLOBAL.ICONS.MERGE}}</mat-icon>
        </button>

        <button mat-fab class="bottom-right pfixed" matTooltip="Different Contacts" (click)="notDuplicate()">
            <mat-icon matListIcon>{{GLOBAL.ICONS.SPLIT}}</mat-icon>
        </button>
    </ng-container>
</ng-container>